/** The value of a linked-email field: which email in which mailbox, plus headers to show it. */
export interface EmailMessageValue {
  connectionId: string
  messageId: string
  threadId?: string | null
  internetMessageId?: string | null
  references?: string | null
  subject?: string | null
  from?: string | null
  replyTo?: string | null
  to?: string | null
  date?: string | null
}

/** The email a stored value points at; null when blank or not a linked email. */
export function parseEmailMessage(raw: string | null | undefined): EmailMessageValue | null {
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as Partial<EmailMessageValue>
    return parsed && typeof parsed.connectionId === 'string' && typeof parsed.messageId === 'string'
      ? (parsed as EmailMessageValue)
      : null
  } catch {
    return null
  }
}

export function formatEmailMessage(value: EmailMessageValue): string {
  return JSON.stringify(value)
}

/**
 * The search the email picker opens with: the field's `defaultSearch` with each `{{field_key}}` filled
 * from the record. An operator left without a value (`from:`) is dropped instead of searching for nothing.
 */
export function fillSearchTemplate(template: string | null | undefined, valuesByKey: Record<string, string>): string {
  if (!template) return ''
  return template
    .replace(/\{\{\s*([^}\s]+)\s*\}\}/g, (_, key: string) => valuesByKey[key]?.trim() ?? '')
    .replace(/\S+:(?=\s|$)/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}
